import Api from '@/services/Api';

export default {
  index() { return Api().get('forms'); },
  getForm(id) { return Api().get(`forms/${id}`); },
  getFormEntries(id, offset) { return Api().get(`forms/${id}/entries?offset=${offset}`); },
  getFormEntryByID(formId, entryId) { return Api().get(`forms/${formId}/entries/${entryId}`); },
  overrideFormEntryByID(formId, entryId) { return Api().put(`forms/${formId}/entries/${entryId}`); },
  createForm(form) { return Api().post('forms', form); },
  editForm(form) { return Api().post(`forms/${form.id}`, form); },
  formStats(id) { return Api().get(`forms${id ? `/${id}/stats` : '/stats'}`); },
};
